<template>
  <BForm
    class="formulario"
    @submit.prevent="gravar">
    <InputBasico
      ref="inputCodigo"
      type="text"
      name="nomeInput"
      label="Código*"
      class="input__codigo"
      v-model="form.codigo"
      v-validate="'required|min:3'"
      :errorsBag="errors"
      :upperCase="true"
    />

    <InputBasico
      type="text"
      name="descricaoInput"
      label="Descrição*"
      class="input__descricao"
      v-model="form.descricao"
      v-validate="'required|min:3'"
      :errorsBag="errors"
    />

    <InputMoeda
      name="precoInput"
      label="Preço"
      class="input__preco"
      v-model="form.preco"
      v-validate="'required|min_value:0.00'"
      :errorsBag="errors"
    />

    <div class="botao__container">
      <BButton
        type="submit"
        class="botao"
        variant="primary">
        Gravar
      </BButton>

      <BButton
        @click.prevent="sair"
        class="botao"
        variant="outline-primary">
        Sair
      </BButton>
    </div>
  </BForm>
</template>

<script>
import { BForm, BButton } from 'bootstrap-vue/es/components'
import FormularioCadastroMixin from '@/mixins/FormularioCadastroMixin'
import InputBasico from '@/components/inputs/InputBasico.vue'
import InputMoeda from '@/components/inputs/InputMoeda.vue'

export default {
  name: 'UsuariosCadastroForm',
  mixins: [FormularioCadastroMixin],
  components: {
    BForm,
    BButton,
    InputBasico,
    InputMoeda,
  },
  mounted() {
    this.$refs.inputCodigo.focar()
  },
  methods: {
    valoresIniciaisForm() {
      return {
        codigo: '',
        descricao: '',
        preco: 0,
      }
    },
    retornaCamposGravar() {
      return this.form
    },
  },
}

</script>

<style lang="scss" scoped>
@import "@/scss/breakpoints.scss";

.formulario {
  display: grid;
  grid-template-columns: 1fr;

  @media (min-width: $small-size) {
    width: 100%;
    grid-template-columns: repeat(12, 1fr);
    grid-column-gap: 0.8em;
  }

  @media (min-width: $extra-large-size) {
    width: $medium-size;
  }
}

.input {
  &__codigo {
    @media (min-width: $small-size) {
      grid-column: 1 / 4;
    }
  }

  &__descricao {
    @media (min-width: $small-size) {
      grid-column: 4 / -1;
    }
  }

  &__preco {
    @media (min-width: $small-size) {
      grid-column: 1 / 4;
    }
  }
}

.botao {
  margin-left: .2rem;

  &__container {
    margin-top: 1rem;
    grid-column: 1 / -1;
    display: flex;
    flex-wrap: nowrap;
    justify-content: flex-end;
  }
}

</style>
